import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import ColorSF2 from '../../styles/common/ColorSF2';
import { Chip } from '../Parts/Chip';
import { convertISOFormatToDate } from '../../lib/tools';
import {
  MainBlock,
  Table,
  Thead,
  TrHead,
  ThTel,
  ScrolledBlock,
  Tbody,
  TrBody,
  TdTel,
  ChipWrapper,
  GroupInfo,
  HomeIcon,
} from './styles/GroupListStyles';

/**
 * グループ管理画面のグループ一覧表を表示するコンポーネント
 * 各グループには、グループ番号、名前、タグセット、最終更新日が表示される。
 * 各グループ項目は、クリックすると詳細ダイアログが開く
 *
 * @param {Object[]} groups 表示するグループの配列。各グループオブジェクトには、
 *                          id, no, name, tagSet, updatedAt, isUsable プロパティが含まれる。
 * @param {function} onOpenDialog グループの項目をクリックした時に呼ばれる関数。グループのIDを引数として渡します。
 */
const GroupLists = ({ groups, onOpenDialog }) => {
  const { formatMessage } = useIntl();
  const createGroupNo = groupNo => {
    const groupNoPadded = String(groupNo).padStart(6, '0');
    return `Grp-${groupNoPadded}`;
  };

  const defaultGroupId = groups.find(group => group.isDefault === true)?.id;

  return (
    <MainBlock>
      <Table>
        <Thead>
          <TrHead>
            <ThTel>
              <FormattedMessage id="group.list.header.number" />
            </ThTel>
            <ThTel>
              <FormattedMessage id="group.list.header.name" />
            </ThTel>
            <ThTel>
              <FormattedMessage id="group.list.header.tagSet" />
            </ThTel>
            <ThTel>
              <FormattedMessage id="group.list.header.lastUpdatedDate" />
            </ThTel>
          </TrHead>
        </Thead>
      </Table>
      <ScrolledBlock id="canGroupScrollTable">
        <Table>
          <Tbody>
            {groups &&
              groups.map(group => {
                const { isUsable } = group;
                return (
                  <TrBody
                    className="clickableItem"
                    id={`group-${group.id}`}
                    key={`${group.id}`}
                    onClick={() => onOpenDialog(group.id)}
                  >
                    <TdTel>
                      <GroupInfo>{createGroupNo(group.no)}</GroupInfo>
                    </TdTel>
                    <TdTel>
                      {group.id === defaultGroupId && (
                        <ChipWrapper>
                          <HomeIcon />
                        </ChipWrapper>
                      )}
                      {!isUsable && (
                        <ChipWrapper>
                          <Chip
                            text={formatMessage({
                              id: 'group.list.batch.deletedGroup',
                            })}
                            bgColor={ColorSF2.steelGray}
                          />
                        </ChipWrapper>
                      )}
                      <GroupInfo>{group.name}</GroupInfo>
                    </TdTel>
                    <TdTel>{group.tagSet ? group.tagSet.name : ''} </TdTel>
                    <TdTel>{convertISOFormatToDate(group.updatedAt)}</TdTel>
                  </TrBody>
                );
              })}
          </Tbody>
        </Table>
      </ScrolledBlock>
    </MainBlock>
  );
};

GroupLists.propTypes = {
  groups: PropTypes.array.isRequired,
  onOpenDialog: PropTypes.func.isRequired,
};

export default GroupLists;
